import { render, staticRenderFns } from "./column4.vue?vue&type=template&id=56f2a432&"
import script from "./column4.vue?vue&type=script&lang=js&"
export * from "./column4.vue?vue&type=script&lang=js&"
import style0 from "./column4.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "column4.vue"
export default component.exports